<template>
    <BilletNonDateTable :userId="userId" />
</template>

<script>
import BilletNonDateTable from './BilletNonDateTable.vue'

export default {
    props: {
        userId: {
            type: [Number, String, null],
            required: false,
            default: null,
        },
    },
    components: {
        BilletNonDateTable,
    },
}
</script>
